import { createSelector } from 'reselect';
import { getDocumentsById } from 'documents/store/documents/selectors';

export const getTrashIsLoading = (state) => state.trash.isLoading;

export const getDeletedDocumentIds = (state) => state.trash.ids;

export const getDeletedDocuments = createSelector(
  [getDeletedDocumentIds, getDocumentsById],
  (ids, documentsById) => (ids.length > 0 ? ids.map((id) => documentsById[id]) : []),
);
